import axios from 'axios'

export const MedPraxSchemeSearch = async (searchQuery, page, pageLimit) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      let response = null

      try {
        response = await axios.post(`${process.env.REACT_APP_NODE_RED_URL}/api/medprax/schemes`, {
          body: {
            filters: [
              {
                propertyName: 'name',
                operation: 'Contains',
                value: searchQuery ? searchQuery : ''
              }
            ],
            filterJoin: 'And',
            ascendingOrder: true,
            sortKey: 'Code'
          },
          pageLimit: 1000,
          page: 1
        })
        resolve(response.data.schemes.pageResult)
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const MedPraxSchemePlanSearch = async (searchQuery, page, pageLimit) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      let response = null

      try {
        response = await axios.post(`${process.env.REACT_APP_NODE_RED_URL}/api/medprax/scheme_plans`, {
          body: {
            filters: [
              {
                propertyName: 'schemeCode',
                operation: 'Equals',
                value: searchQuery
              }
            ],
            filterJoin: 'And',
            ascendingOrder: true,
            sortKey: 'Code'
          },
          pageLimit: 100,
          page: 1
        })
        resolve(response.data.plans.pageResult)
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const MedPraxSchemePlanOptionSearch = async (searchQuery, page, pageLimit) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      let response = null

      try {
        response = await axios.post(`${process.env.REACT_APP_NODE_RED_URL}/api/medprax/scheme_plan_options`, {
          body: {
            filters: [
              {
                propertyName: 'planCode',
                operation: 'Equals',
                value: searchQuery
              }
            ],
            filterJoin: 'And',
            ascendingOrder: true,
            sortKey: 'Code'
          },
          pageLimit: 100,
          page: 1
        })
        resolve(response.data.planOptions.pageResult)
      } catch (e) {
        reject(e)
      }
    })()
  })
}
